import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import API from "../../services/api";
import toast from "react-hot-toast";

function ReceivePurchasePayment() {

    const navigate = useNavigate();
    const location = useLocation();
    const fromPurchase = !!location.state?.purchase;

    const [purchases, setPurchases] = useState([]);
    const [wallets, setWallets] = useState([]);
    const [selectedPurchase, setSelectedPurchase] = useState(null);

    const [form, setForm] = useState({
        purchase_id: "",
        wallet_id: "",
        paid_amount: "",
        note: ""
    });

    useEffect(() => {

        loadData();

    }, []);

    const loadData = async () => {

        try {

            const [

                purchaseRes,

                walletRes

            ] = await Promise.all([

                API.get("/purchases"),

                API.get("/wallets")

            ]);

            /*
            Only purchases having due amount
            */

            setPurchases(

                (purchaseRes.data.purchases || []).filter(
                    item =>
                        Number(item.due_amount) > 0
                )
            );

            setWallets(
                walletRes.data.wallets || []
            );

            /*
            =====================================
            PRESELECT PURCHASE
            =====================================
            */

            if (location.state?.purchase) {

                const purchase = location.state.purchase;

                const selected = (
                    purchaseRes.data.purchases || []
                ).find(
                    item => item.id === purchase.id
                );

                if (selected) {

                    setSelectedPurchase(selected);

                    setForm(prev => ({

                        ...prev,

                        purchase_id: selected.id,

                        paid_amount: selected.due_amount

                    }));

                }

            }

        } catch (err) {

            console.log(err);

        }

    };

    const selectPurchase = (purchase) => {

        setSelectedPurchase(purchase);

        setForm({

            ...form,

            purchase_id: purchase.id,

            paid_amount: purchase.due_amount

        });

    };

    const submitPayment = async (e) => {

        e.preventDefault();

        try {

            if (!form.purchase_id) {

                return toast.error(
                    "Please select a purchase."
                );

            }

            if (!form.wallet_id) {

                return toast.error(
                    "Please select a wallet."
                );

            }

            if (

                Number(form.paid_amount) <= 0

            ) {

                return toast.error(
                    "Enter a valid payment amount."
                );

            }

            if (

                Number(form.paid_amount) >

                Number(selectedPurchase.due_amount)

            ) {

                return toast.error(
                    "Payment cannot exceed due amount."
                );

            }

            await API.post(
                "/purchases/receive-payment",
                form
            );

            toast.success(
                "Payment received successfully."
            );

            navigate(
                "/admin/purchases"
            );

        } catch (err) {

            console.log(err);

            toast.error(

                err.response?.data?.message ||

                "Server Error"

            );

        }

    };

    return (

        <div>

            <div
                className="
                flex
                justify-between
                items-center
                mb-8
                "
            >

                <h1
                    className="
                    text-4xl
                    font-bold
                    "
                >
                    Pay Purchase Payment
                </h1>

                <button
                    onClick={() => navigate(-1)}
                    className="
                    bg-yellow-500
                    text-black
                    px-6
                    py-3
                    rounded-xl
                    "
                >
                    Back
                </button>

            </div>

            <div
                className="
                bg-[#111]
                rounded-2xl
                border
                border-yellow-500/20
                p-8
                "
            >
                <form>

                    {/* Purchase */}

                    <div className="mb-6">

                        <label className="block mb-2 font-semibold">
                            Purchase
                        </label>

                        <Select
                            isDisabled={fromPurchase}
                            className="text-dark"

                            value={
                                selectedPurchase
                                    ? {
                                        value: selectedPurchase.id,
                                        label: `${selectedPurchase.invoice_no} • ${selectedPurchase.supplier_name}`,
                                        purchase: selectedPurchase
                                    }
                                    : null
                            }

                            options={

                                purchases.map(item => ({

                                    value: item.id,

                                    label: `${item.invoice_no} • ${item.supplier_name}`,

                                    purchase: item

                                }))

                            }

                            onChange={(selected) =>
                                selectPurchase(
                                    selected.purchase
                                )
                            }

                            placeholder="Select Purchase"
                        />

                    </div>

                    {
                        selectedPurchase && (

                            <>

                                <div
                                    className="
                                    grid
                                    md:grid-cols-4
                                    gap-5
                                    mb-8
                                    "
                                >

                                    <div
                                        className="
                                        bg-black/40
                                        rounded-xl
                                        p-5
                                        "
                                    >

                                        <p className="text-gray-400">
                                            Supplier
                                        </p>

                                        <h3
                                            className="
                                            text-xl
                                            font-bold
                                            mt-2
                                            "
                                        >
                                            {selectedPurchase.supplier_name}
                                        </h3>

                                    </div>

                                    <div
                                        className="
                                        bg-black/40
                                        rounded-xl
                                        p-5
                                        "
                                    >

                                        <p className="text-gray-400">
                                            Grand Total
                                        </p>

                                        <h3
                                            className="
                                            text-2xl
                                            font-bold
                                            text-yellow-400
                                            mt-2
                                            "
                                        >
                                            ₹
                                            {
                                                Number(
                                                    selectedPurchase.grand_total
                                                ).toFixed(2)
                                            }
                                        </h3>

                                    </div>

                                    <div
                                        className="
                                        bg-black/40
                                        rounded-xl
                                        p-5
                                        "
                                    >

                                        <p className="text-gray-400">
                                            Paid
                                        </p>

                                        <h3
                                            className="
                                            text-2xl
                                            font-bold
                                            text-green-400
                                            mt-2
                                            "
                                        >
                                            ₹
                                            {
                                                Number(
                                                    selectedPurchase.paid_amount
                                                ).toFixed(2)
                                            }
                                        </h3>

                                    </div>

                                    <div
                                        className="
                                        bg-black/40
                                        rounded-xl
                                        p-5
                                        "
                                    >

                                        <p className="text-gray-400">
                                            Due
                                        </p>

                                        <h3
                                            className="
                                            text-2xl
                                            font-bold
                                            text-red-400
                                            mt-2
                                            "
                                        >
                                            ₹
                                            {
                                                Number(
                                                    selectedPurchase.due_amount
                                                ).toFixed(2)
                                            }
                                        </h3>

                                    </div>

                                </div>

                                {/* Wallet */}

                                <div className="mb-5">

                                    <label className="block mb-2 font-semibold">
                                        Wallet
                                    </label>

                                    <select

                                        value={form.wallet_id}

                                        onChange={(e) =>

                                            setForm({

                                                ...form,

                                                wallet_id:
                                                    e.target.value

                                            })

                                        }

                                        className="
                                        w-full
                                        p-3
                                        rounded-xl
                                        bg-black
                                        border
                                        border-yellow-500/20
                                        "

                                    >

                                        <option value="">
                                            Select Wallet
                                        </option>

                                        {

                                            wallets.map(wallet => (

                                                <option
                                                    key={wallet.id}
                                                    value={wallet.id}
                                                >

                                                    {wallet.wallet_name}

                                                    {" "}

                                                    (₹

                                                    {

                                                        Number(
                                                            wallet.balance
                                                        ).toFixed(2)

                                                    }

                                                    )

                                                </option>

                                            ))

                                        }

                                    </select>

                                </div>

                                {/* Payment */}

                                <div className="mb-5">

                                    <label className="block mb-2 font-semibold">
                                        Payment Amount
                                    </label>

                                    <input

                                        type="number"

                                        min="1"

                                        max={
                                            selectedPurchase.due_amount
                                        }

                                        value={form.paid_amount}

                                        onChange={(e) =>

                                            setForm({

                                                ...form,

                                                paid_amount:
                                                    e.target.value

                                            })

                                        }

                                        className="
                                        w-full
                                        p-3
                                        rounded-xl
                                        bg-black
                                        border
                                        border-yellow-500/20
                                        "

                                    />

                                </div>

                                {/* Note */}

                                <div className="mb-5">

                                    <label className="block mb-2 font-semibold">
                                        Note
                                    </label>

                                    <textarea

                                        rows={4}

                                        value={form.note}

                                        onChange={(e) =>

                                            setForm({

                                                ...form,

                                                note:
                                                    e.target.value

                                            })

                                        }

                                        className="
                                        w-full
                                        p-3
                                        rounded-xl
                                        bg-black
                                        border
                                        border-yellow-500/20
                                        "

                                    />

                                </div>

                            </>

                        )
                    }

                    {/* Buttons */}

                    {
                        selectedPurchase && (

                            <div
                                className="
                                flex
                                justify-end
                                gap-4
                                mt-8
                                "
                            >

                                <button

                                    type="button"

                                    onClick={() =>

                                        navigate(
                                            "/admin/purchases"
                                        )

                                    }

                                    className="
                                    px-6
                                    py-3
                                    rounded-xl
                                    bg-gray-700
                                    hover:bg-gray-600
                                    transition
                                    "

                                >

                                    Cancel

                                </button>

                                <button

                                    type="button"

                                    onClick={submitPayment}

                                    className="
                                    px-8
                                    py-3
                                    rounded-xl
                                    bg-green-600
                                    hover:bg-green-500
                                    font-bold
                                    transition
                                    "

                                >

                                    Receive Payment

                                </button>

                            </div>

                        )

                    }

                </form>

            </div>

        </div>

    );

}

export default ReceivePurchasePayment;